'use strict';

/**
 *
 * @name: nownessApp.search
 *
 */

const SearchModule = angular
  .module('nownessApp.search', []);

export default SearchModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-search-modal/nn-search.module.js